module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/equipment05-899b7fb70d27b3605c9ffdf6a1c98656.png";